import React, { useEffect, useState } from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { Button } from '@3plearning/react-components';
import BackIcon from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_back.svg';
import { useLocalisation } from '@3plearning/lingui-cdn';

import css from './top-level-info.scss';

import { SELECTED_STUDENT } from '../../../../../components/report-filters/filter-constants';
import { activeFiltersPropType } from '../../../../../components/report-filters/filter-prop-types';

/**
 * SKILL QUESTS MASTERY TOP LEVEL INFO
 * -----------------------------------------
 * Manages all left hand side functionality of student skill quests
 */
const TopLevelInfo = ({
    academicYear,
    activeFilters,
    getDateLabel,
    history,
    isAdmin
}) => {
    const { i18n } = useLocalisation();
    const text = {
        headingLabelText: (name) => i18n.t`Top Level Info - ${name}`
    };
    const [headingLabel, setHeadingLabel] = useState('');
    const [dateLabel, setDateLabel] = useState('');

    const manageHeadingLabels = () => {
        const { headingLabelText } = text;
        const studentName = activeFilters[SELECTED_STUDENT].name;

        setHeadingLabel(studentName ? headingLabelText(studentName) : '');
        setDateLabel(getDateLabel());
    };

    const manageFilterValueChange = () => {
        if (isAdmin !== null) {
            manageHeadingLabels();
        }
    };

    const onBackNavigation = () => history.goBack();

    useEffect(() => {
        manageFilterValueChange();
    }, [activeFilters, academicYear, isAdmin]);

    return (
        <div className={css['top-level-info-container']}>
            <Button
                className={css['top-level-info-button']}
                icon={BackIcon}
                onClick={onBackNavigation}
            />
            <div className={css['header-container']}>
                <h2 title={headingLabel}>{headingLabel}</h2>
                <div className={css['date-range']}>{dateLabel}</div>
            </div>
        </div>
    );
};

TopLevelInfo.propTypes = {
    academicYear: PropTypes.shape({
        startDate: PropTypes.string,
        endDate: PropTypes.string
    }),
    activeFilters: activeFiltersPropType,
    getDateLabel: PropTypes.func,
    history: PropTypes.any,
    isAdmin: PropTypes.bool
};

export default styleable(css)(TopLevelInfo);



// WEBPACK FOOTER //
// ./containers/skill-quests-mastery/student/components/top-level-info/top-level-info.js